import { createApp } from 'vue'
import { createGtm } from '@gtm-support/vue-gtm'
import App from './App.vue'
import router from './router'
import store from './store'
import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import { dragscrollNext } from 'vue-dragscroll'

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_URL,
  release: 'my-project-name@' + process.env.npm_package_version,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0
})

const app = createApp(App)
app.config.errorHandler = (err, vm, info) => {
  console.error(`Captured in Vue.config.errorHandler: ${info}`, err)
  Sentry.captureException(err)
}
app.directive('dragscroll', dragscrollNext)
app
  .use(store)
  .use(router)
  .use(
    createGtm({
      id: 'GTM-N88Z9T',
      vueRouter: router,
      trackOnNextTick: true
    })
  )
  .mount('#app')

window.addEventListener('error', (event) => {
  Sentry.captureException(event)
})
window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event)
})
